import { ExpandMore } from '@mui/icons-material';
import { Button, Grid, Menu, MenuItem, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

BudgetMenu.propTypes = {
  menuElements: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default function BudgetMenu({ menuElements, value, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleChange = (e) => {
    onChange(e);
    handleClose();
  }
  const handleClose = () => {
    setAnchorEl(null);
  };
  const buttonLabel = value || "choose";

  return (
    <>
      <Typography variant="caption">
        Review if over <Button size="small" color="primary" endIcon={<ExpandMore />} onClick={handleClick}>{buttonLabel}</Button> budget
      </Typography>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'Budget-Menu-Button' }}
      >
        {menuElements?.map((elem, index) => (
          <MenuItem dense key={index} onClick={() => handleChange(elem)}>
            <Grid item>{elem}</Grid>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
